(function () {
  const config = window.ITMartCategoryNavigation || {};
  const targetSelector = '[data-category-menu], [data-category-drawer], [data-category-directory]';
  let categoryDataPromise;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function rootPath() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function buildStoreUrl(path) {
    const root = rootPath().replace(/\/$/, '');
    const normalizedPath = String(path || '').startsWith('/') ? path : '/' + String(path || '');
    return (root || '') + normalizedPath;
  }

  function getBrowseUrl(element, category) {
    return element.dataset.browseUrl || buildStoreUrl(category.browse_page_url);
  }

  function normalizeCategoryName(categoryName) {
    return String(categoryName || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function getComparisonUrl(categoryName) {
    const normalizedCategoryName = normalizeCategoryName(categoryName);
    const comparisonPath = '/pages/comparison';
    const categoryHashes = {
      'cloud services': 'cloud-services',
      'ai tools': 'ai-tools',
      'software': 'software'
    };
    const hash = categoryHashes[normalizedCategoryName];

    return buildStoreUrl(hash ? comparisonPath + '#' + hash : comparisonPath);
  }

  function actionButtonsMarkup(options) {
    return [
      '<div class="category-navigation__actions' + (options.actionsClassName ? ' ' + options.actionsClassName : '') + '">',
      '<a class="button button--secondary ' + escapeHtml(options.comparisonClassName) + '" href="' + escapeHtml(options.comparisonUrl) + '">Comparisons</a>',
      '<a class="button button--secondary ' + escapeHtml(options.browseClassName) + '" href="' + escapeHtml(options.browseUrl) + '">Browse more</a>',
      '</div>',
    ].join('');
  }

  function getPreviewSubcategoryCount(payload) {
    return Number(config.previewSubcategoryCount || payload.preview_subcategory_count || 5);
  }

  function fetchCategoryData() {
    if (categoryDataPromise) {
      return categoryDataPromise;
    }

    if (!config.dataUrl) {
      return Promise.resolve(null);
    }

    categoryDataPromise = fetch(config.dataUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load category navigation data.');
        }

        return response.json();
      })
      .then(function (payload) {
        const topCategories = Array.isArray(payload.top_categories) ? payload.top_categories : [];
        const categoryLookup = {};

        topCategories.forEach(function (category) {
          categoryLookup[category.slug] = category;
        });

        payload.categoryLookup = categoryLookup;
        return payload;
      })
      .catch(function (error) {
        console.error(error);
        return null;
      });

    return categoryDataPromise;
  }

  function desktopSubcategoryCard(category, subcategory, browseUrl) {
    if (category.is_flat_category) {
      const collectionUrl = buildStoreUrl(subcategory.collection_url);
      return [
        '<article class="category-menu-card category-menu-card--flat">',
        '<a class="category-menu-card__title" href="' + escapeHtml(collectionUrl) + '">' + escapeHtml(subcategory.name) + '</a>',
        '<p class="category-menu-card__meta">Direct product collection</p>',
        '<a class="category-menu-card__cta" href="' + escapeHtml(collectionUrl) + '">View products</a>',
        '</article>',
      ].join('');
    }

    const finalLinks = subcategory.final_categories
      .map(function (finalCategory) {
        return [
          '<li>',
          '<a href="' + escapeHtml(buildStoreUrl(finalCategory.collection_url)) + '">' + escapeHtml(finalCategory.name) + '</a>',
          '</li>',
        ].join('');
      })
      .join('');

    return [
      '<article class="category-menu-card">',
      '<div class="category-menu-card__header">',
      '<a class="category-menu-card__title" href="' + escapeHtml(browseUrl + '#' + subcategory.slug) + '">' + escapeHtml(subcategory.name) + '</a>',
      '<span class="category-menu-card__count">' + escapeHtml(subcategory.final_count) + ' collections</span>',
      '</div>',
      '<ul class="category-menu-card__links">',
      finalLinks,
      '</ul>',
      '<a class="category-menu-card__more" href="' + escapeHtml(browseUrl + '#' + subcategory.slug) + '">See all</a>',
      '</article>',
    ].join('');
  }

  function renderDesktopMenu(element, category, payload) {
    const browseUrl = getBrowseUrl(element, category);
    const comparisonUrl = getComparisonUrl(category.name);
    const previewSubcategories = category.subcategories.slice(0, getPreviewSubcategoryCount(payload));
    const cards = previewSubcategories
      .map(function (subcategory) {
        return desktopSubcategoryCard(category, subcategory, browseUrl);
      })
      .join('');

    element.innerHTML = [
      '<div class="category-menu-shell__intro">',
      '<div>',
      '<p class="category-menu-shell__eyebrow">Curated navigation</p>',
      '<h3 class="category-menu-shell__title">' + escapeHtml(category.name) + '</h3>',
      '<p class="category-menu-shell__meta">' +
        escapeHtml(category.subcategory_count) +
        ' subcategories · ' +
        escapeHtml(category.final_category_count) +
        ' collections</p>',
      '</div>',
      actionButtonsMarkup({
        actionsClassName: 'category-menu-shell__actions',
        comparisonClassName: 'category-navigation__comparison-button',
        comparisonUrl: comparisonUrl,
        browseClassName: 'category-menu-shell__browse category-navigation__browse-button',
        browseUrl: browseUrl
      }),
      '</div>',
      '<div class="category-menu-shell__grid' + (category.is_flat_category ? ' category-menu-shell__grid--flat' : '') + '">',
      cards,
      '</div>',
    ].join('');
  }

  function drawerGroupMarkup(category, subcategory) {
    if (category.is_flat_category) {
      return [
        '<a class="category-drawer-group category-drawer-group--flat" href="' + escapeHtml(buildStoreUrl(subcategory.collection_url)) + '">',
        '<span class="category-drawer-group__title">' + escapeHtml(subcategory.name) + '</span>',
        '<span class="category-drawer-group__meta">View products</span>',
        '</a>',
      ].join('');
    }

    const finalLinks = subcategory.final_categories
      .map(function (finalCategory) {
        return [
          '<li>',
          '<a href="' + escapeHtml(buildStoreUrl(finalCategory.collection_url)) + '">' + escapeHtml(finalCategory.name) + '</a>',
          '</li>',
        ].join('');
      })
      .join('');

    return [
      '<details class="category-drawer-group">',
      '<summary class="category-drawer-group__summary">',
      '<span>' + escapeHtml(subcategory.name) + '</span>',
      '<span class="category-drawer-group__count">' + escapeHtml(subcategory.final_count) + '</span>',
      '</summary>',
      '<ul class="category-drawer-group__links">',
      finalLinks,
      '</ul>',
      '</details>',
    ].join('');
  }

  function renderDrawerMenu(element, category, payload) {
    const browseUrl = getBrowseUrl(element, category);
    const comparisonUrl = getComparisonUrl(category.name);
    const previewSubcategories = category.subcategories.slice(0, getPreviewSubcategoryCount(payload));
    const groups = previewSubcategories
      .map(function (subcategory) {
        return drawerGroupMarkup(category, subcategory);
      })
      .join('');

    element.innerHTML = [
      '<div class="category-drawer-panel__intro">',
      '<p class="category-drawer-panel__eyebrow">Quick browse</p>',
      '<p class="category-drawer-panel__meta">' +
        escapeHtml(previewSubcategories.length) +
        ' featured categories of ' +
        escapeHtml(category.subcategory_count) +
        '</p>',
      actionButtonsMarkup({
        actionsClassName: 'category-drawer-panel__actions',
        comparisonClassName: 'category-navigation__comparison-button',
        comparisonUrl: comparisonUrl,
        browseClassName: 'category-drawer-panel__browse category-navigation__browse-button',
        browseUrl: browseUrl
      }),
      '</div>',
      '<div class="category-drawer-panel__groups">',
      groups,
      '</div>',
    ].join('');
  }

  function directoryHeaderMarkup(category) {
    return [
      '<div class="category-directory__hero-copy">',
      '<p class="category-directory__eyebrow">Category explorer</p>',
      '<h1 class="category-directory__title">' + escapeHtml(category.name) + '</h1>',
      '<p class="category-directory__description">Explore carefully organized options, compare solutions faster, and discover the tools and services that fit your needs with confidence.</p>',
      '<p class="category-directory__stats">' +
        escapeHtml(category.subcategory_count) +
        ' subcategories · ' +
        escapeHtml(category.final_category_count) +
        ' collections</p>',
      '</div>',
      '<label class="category-directory__search">',
      '<span class="visually-hidden">Search categories</span>',
      '<input type="search" placeholder="Search categories" data-category-directory-search>',
      '</label>',
    ].join('');
  }

  function standardDirectorySectionMarkup(subcategory) {
    const finalCards = subcategory.final_categories
      .map(function (finalCategory) {
        return [
          '<a class="category-directory-card" href="' + escapeHtml(buildStoreUrl(finalCategory.collection_url)) + '" data-searchable="' + escapeHtml((subcategory.name + ' ' + finalCategory.name).toLowerCase()) + '">',
          '<span class="category-directory-card__title">' + escapeHtml(finalCategory.name) + '</span>',
          '<span class="category-directory-card__meta">Collection</span>',
          '</a>',
        ].join('');
      })
      .join('');

    return [
      '<section id="' + escapeHtml(subcategory.slug) + '" class="category-directory-section" data-category-section data-section-name="' + escapeHtml(subcategory.name.toLowerCase()) + '">',
      '<div class="category-directory-section__header">',
      '<h2 class="category-directory-section__title">' + escapeHtml(subcategory.name) + '</h2>',
      '<span class="category-directory-section__count">' + escapeHtml(subcategory.final_count) + ' collections</span>',
      '</div>',
      '<div class="category-directory-section__grid">',
      finalCards,
      '</div>',
      '</section>',
    ].join('');
  }

  function softwareDirectoryMarkup(category) {
    const groups = {};
    const letters = [];

    category.subcategories.forEach(function (subcategory) {
      const groupKey = (subcategory.name.charAt(0).match(/[A-Z]/i) || ['#'])[0].toUpperCase();

      if (!groups[groupKey]) {
        groups[groupKey] = [];
        letters.push(groupKey);
      }

      groups[groupKey].push(subcategory);
    });

    const quickLinks = letters
      .map(function (letter) {
        return '<a href="#category-letter-' + escapeHtml(letter) + '">' + escapeHtml(letter) + '</a>';
      })
      .join('');

    const sections = letters
      .sort()
      .map(function (letter) {
        const cards = groups[letter]
          .map(function (subcategory) {
            return [
              '<a class="category-directory-card category-directory-card--software" href="' + escapeHtml(buildStoreUrl(subcategory.collection_url)) + '" data-searchable="' + escapeHtml(subcategory.name.toLowerCase()) + '">',
              '<span class="category-directory-card__title">' + escapeHtml(subcategory.name) + '</span>',
              '<span class="category-directory-card__meta">Collection</span>',
              '</a>',
            ].join('');
          })
          .join('');

        return [
          '<section id="category-letter-' + escapeHtml(letter) + '" class="category-directory-section category-directory-section--letter" data-category-section>',
          '<div class="category-directory-section__header">',
          '<h2 class="category-directory-section__title">' + escapeHtml(letter) + '</h2>',
          '<span class="category-directory-section__count">' + escapeHtml(groups[letter].length) + ' collections</span>',
          '</div>',
          '<div class="category-directory-section__grid category-directory-section__grid--software">',
          cards,
          '</div>',
          '</section>',
        ].join('');
      })
      .join('');

    return [
      '<nav class="category-directory__quicklinks category-directory__quicklinks--letters">',
      quickLinks,
      '</nav>',
      sections,
    ].join('');
  }

  function standardDirectoryMarkup(category) {
    const quickLinks = category.subcategories
      .map(function (subcategory) {
        return '<a href="#' + escapeHtml(subcategory.slug) + '">' + escapeHtml(subcategory.name) + '</a>';
      })
      .join('');

    const sections = category.subcategories
      .map(function (subcategory) {
        return standardDirectorySectionMarkup(subcategory);
      })
      .join('');

    return [
      '<nav class="category-directory__quicklinks">',
      quickLinks,
      '</nav>',
      sections,
    ].join('');
  }

  function bindDirectorySearch(element, category) {
    const input = element.querySelector('[data-category-directory-search]');

    if (!input) {
      return;
    }

    const emptyState = element.querySelector('[data-category-empty-state]');
    const sections = Array.prototype.slice.call(element.querySelectorAll('[data-category-section]'));

    function update() {
      const query = input.value.trim().toLowerCase();
      let visibleSectionCount = 0;

      sections.forEach(function (section) {
        const cards = Array.prototype.slice.call(section.querySelectorAll('[data-searchable]'));
        let visibleCards = 0;
        const sectionName = (section.getAttribute('data-section-name') || '').toLowerCase();
        const sectionNameMatch = !category.is_flat_category && query && sectionName.indexOf(query) > -1;

        cards.forEach(function (card) {
          const cardSearchable = (card.getAttribute('data-searchable') || '').toLowerCase();
          const match = !query || sectionNameMatch || cardSearchable.indexOf(query) > -1;
          card.hidden = !match;

          if (match) {
            visibleCards += 1;
          }
        });

        const showSection = !query || visibleCards > 0;

        section.hidden = !showSection;

        if (showSection) {
          visibleSectionCount += 1;
        }
      });

      if (emptyState) {
        emptyState.hidden = visibleSectionCount > 0;
      }
    }

    input.addEventListener('input', update);
    update();
  }

  function scrollToDirectoryHash(element) {
    if (!window.location.hash) return;

    const targetId = decodeURIComponent(window.location.hash.slice(1));
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target || !element.contains(target)) return;

    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.setTimeout(function () {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 0);
  }

  function renderDirectory(element, category) {
    const bodyMarkup = category.is_flat_category ? softwareDirectoryMarkup(category) : standardDirectoryMarkup(category);

    element.innerHTML = [
      '<div class="page-width category-directory-shell">',
      '<header class="category-directory__hero">',
      directoryHeaderMarkup(category),
      '</header>',
      '<div class="category-directory__body">',
      bodyMarkup,
      '<div class="category-directory__empty" data-category-empty-state hidden>No categories matched your search.</div>',
      '</div>',
      '</div>',
    ].join('');

    bindDirectorySearch(element, category);
    scrollToDirectoryHash(element);
  }

  function renderTargets(payload) {
    const targets = document.querySelectorAll(targetSelector);

    targets.forEach(function (element) {
      const categorySlug = element.dataset.categoryMenu || element.dataset.categoryDrawer || element.dataset.categoryDirectory;
      const category = payload.categoryLookup[categorySlug];

      if (!category) {
        element.innerHTML = '<p class="category-navigation__error">Category data is unavailable for this page.</p>';
        return;
      }

      if (element.hasAttribute('data-category-menu')) {
        renderDesktopMenu(element, category, payload);
        return;
      }

      if (element.hasAttribute('data-category-drawer')) {
        renderDrawerMenu(element, category, payload);
        return;
      }

      if (element.hasAttribute('data-category-directory')) {
        renderDirectory(element, category);
      }
    });
  }

  function init() {
    if (!document.querySelector(targetSelector)) {
      return;
    }

    fetchCategoryData().then(function (payload) {
      if (payload) {
        renderTargets(payload);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
